import { render, staticRenderFns } from "./appointmentxhIndex.vue?vue&type=template&id=0a25ec5f&scoped=true&"
import script from "./appointmentxhIndex.vue?vue&type=script&lang=js&"
export * from "./appointmentxhIndex.vue?vue&type=script&lang=js&"
import style0 from "./appointmentxhIndex.vue?vue&type=style&index=0&id=0a25ec5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a25ec5f",
  null
  
)

export default component.exports